import { MAX_CART_LENGTH, MAX_PRODUCT_IN_CART } from 'types/client';

export const MAX_PRODUCT_IN_CART_ERROR = `O seu carrinho já possui a quantidade máxima de ${MAX_PRODUCT_IN_CART} itens deste produto.`;
export const MAX_CART_LENGTH_ERROR = `Você já possui o máximo de ${MAX_CART_LENGTH} itens no seu carrinho.`;
export const CHANGE_PAYMENT_METHOD_LABEL = 'Alterar dados de pagamento';
export const ADD_CARD_LABEL = 'Adicionar um cartão';
